import clsx from 'clsx'
import { AnimatePresence, motion } from 'framer-motion'
import { useRouter } from 'next/router'
import { ReactNode } from 'react'
import { NavigationResult, Settings } from '@/src/@types/statamic'
import { SearchDialogProvider } from '@/src/components/flch/components/SearchDialog'
import DesktopNav from '@/src/components/flch/navigation/DesktopNav'
import Footer from '@/src/components/flch/navigation/Footer'
import MobileNav from '@/src/components/flch/navigation/MobileNav'
import useWindowScrolled from '@/src/hooks/useWindowScrolled'
import Navigation from '@/src/lib/Navigation'
import { statamicConfig } from '@/src/StatamicGraphQLClient'

export default function BaseLayout({
  children,
  navs,
  settings,
}: {
  children: ReactNode
  navs: NavigationResult['navs']
  settings: Settings['settings']
}) {
  const router = useRouter()

  const scrolled = useWindowScrolled(10)

  // prevent transitioning on change of query params
  const transitionKey = router.asPath.split('?')[0]

  const navigations = Navigation(navs)

  const primaryNavigation = navigations.get(statamicConfig.navHandle)
  const footerNavigation = navigations.get(statamicConfig.footerNavHandle)

  return (
    <SearchDialogProvider>
      <div className="relative flex min-h-screen flex-col">
        <div
          className={clsx('fixed inset-x-0 top-0 z-10', {
            'bg-white': scrolled,
          })}
          style={{
            paddingRight: 'var(--removed-body-scroll-bar-size, 0px)',
          }}
        >
          <div className="hidden xl:block">
            <DesktopNav
              scrolled={scrolled}
              mainNavigation={primaryNavigation}
            />
          </div>
          <div className="xl:hidden">
            <MobileNav scrolled={scrolled} mainNavigation={primaryNavigation} />
          </div>
        </div>
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            className="relative z-0 flex flex-1 flex-col"
            key={transitionKey}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.1 }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
        <footer>
          <Footer footerNavigation={footerNavigation} settings={settings} />
        </footer>
      </div>
    </SearchDialogProvider>
  )
}
